// Dark mode only — light mode removed
export function useTheme() {
  return { isDark: true, toggleTheme: () => {} };
}